export const content = {
  heading: "Still need help?",
  headline: "Contact us",
  byline: "We're here to help. Get in touch online or over the phone.",
  href: "https://www.originenergy.com.au/contact",
};
